module.exports = __webpack_public_path__ + "img/scene17.e0e1ffac.gif";